export default {
  label: 'Notifications',
  empty: 'There are no notifications available',
  mark_as_seen: 'Mark as read',
  mark_all_as_seen: 'Mark all as read'
};
